{
    "appHint": "main",
    "apps": {
        "main": {
            "name": "Solomon",
            "shortName": "App",
            "version": "1.0.0",
            "environments": {
                "Development": {
                    "config": {
                        "rpcEndpoint": "https://chloe-w2qjqk-fast-mainnet.helius-rpc.com",
                        "network": "mainnet-beta",
                        "apiUrls": {
                            "solomonData": "https://data-dev.solomonlabs.io",
                            "yaas": "http://localhost:4000",
                            "yaasMetrics": "https://yaas.solomonlabs.io",
                            "rewards": "https://rewards-dev.solomonlabs.io/api"
                        },
                        "verificationWallet": "EAbdqx7EK7qJoDVJwyRocRAU1oKm4PXtBRqZBW51k7HJ",
                        "featureFlags": {
                            "yaasNav": false,
                            "portfolio": false,
                            "clientOperatingContextSelection": true,
                            "complianceModuleUi": true,
                            "clientComplianceSurface": false,
                            "clientMultiDestinationRouting": true,
                            "clientConsoleAccess": true,
                            "clientFullOnboarding": false,
                            "retailMicroTransferVerification": true,
                            "retailSquadsMultisig": false,
                            "retailPositionRouting": true,
                            "retailRaydiumLpFallback": true,
                            "retailLpApiDiscovery": true,
                            "retailMultiDestinationRouting": false,
                            "retailEnrollmentDestination": false,
                            "retailDistributionModeChoice": false,
                            "venues": false,
                            "reserveHistoryPreview": true
                        }
                    },
                    "environment": "Development"
                },
                "Staging": {
                    "config": {
                        "rpcEndpoint": "https://chloe-w2qjqk-fast-mainnet.helius-rpc.com",
                        "network": "mainnet-beta",
                        "apiUrls": {
                            "solomonData": "https://data-dev.solomonlabs.io",
                            "yaas": "https://yaas-dev.solomonlabs.io",
                            "yaasMetrics": "https://yaas.solomonlabs.io",
                            "rewards": "https://rewards-dev.solomonlabs.io/api"
                        },
                        "verificationWallet": "EAbdqx7EK7qJoDVJwyRocRAU1oKm4PXtBRqZBW51k7HJ",
                        "featureFlags": {
                            "yaasNav": false,
                            "portfolio": false,
                            "clientOperatingContextSelection": true,
                            "complianceModuleUi": true,
                            "clientComplianceSurface": false,
                            "clientMultiDestinationRouting": false,
                            "clientConsoleAccess": true,
                            "clientFullOnboarding": true,
                            "retailMicroTransferVerification": true,
                            "retailSquadsMultisig": false,
                            "retailPositionRouting": false,
                            "retailRaydiumLpFallback": true,
                            "retailLpApiDiscovery": true,
                            "retailMultiDestinationRouting": false,
                            "retailEnrollmentDestination": false,
                            "retailDistributionModeChoice": false,
                            "venues": false,
                            "reserveHistoryPreview": true
                        }
                    },
                    "environment": "Staging"
                },
                "Production": {
                    "config": {
                        "rpcEndpoint": "https://chloe-w2qjqk-fast-mainnet.helius-rpc.com",
                        "network": "mainnet-beta",
                        "apiUrls": {
                            "solomonData": "https://data.solomonlabs.io",
                            "yaas": "https://yaas.solomonlabs.io",
                            "yaasMetrics": "https://yaas.solomonlabs.io",
                            "rewards": "https://rewards.solomonlabs.io/api"
                        },
                        "verificationWallet": "EAbdqx7EK7qJoDVJwyRocRAU1oKm4PXtBRqZBW51k7HJ",
                        "featureFlags": {
                            "yaasNav": false,
                            "portfolio": false,
                            "clientOperatingContextSelection": true,
                            "complianceModuleUi": true,
                            "clientComplianceSurface": false,
                            "clientMultiDestinationRouting": false,
                            "clientConsoleAccess": true,
                            "clientFullOnboarding": false,
                            "retailMicroTransferVerification": true,
                            "retailSquadsMultisig": false,
                            "retailPositionRouting": true,
                            "retailRaydiumLpFallback": true,
                            "retailLpApiDiscovery": true,
                            "retailMultiDestinationRouting": false,
                            "retailEnrollmentDestination": false,
                            "retailDistributionModeChoice": false,
                            "venues": false,
                            "reserveHistoryPreview": false
                        }
                    },
                    "environment": "Production"
                }
            }
        },
        "yaas-client": {
            "name": "Solomon Platform",
            "shortName": "Company Recipient",
            "version": "1.0.0",
            "environments": {
                "Development": {
                    "config": {
                        "oauth": {
                            "apiBase": "http://localhost:4000",
                            "clientId": "client-console-dev",
                            "redirectUri": "http://localhost:3400/callback",
                            "scope": "openid profile offline_access",
                            "externalAuth": {
                                "google": {
                                    "enabled": true,
                                    "label": "Continue with Google"
                                },
                                "sso": {
                                    "enabled": false,
                                    "label": "Continue with SSO"
                                }
                            }
                        }
                    },
                    "environment": "Development"
                },
                "Staging": {
                    "config": {
                        "oauth": {
                            "apiBase": "https://yaas-dev.solomonlabs.io",
                            "clientId": "client-console-dev",
                            "redirectUri": "https://staging--solomon-platform.netlify.app/callback",
                            "scope": "openid profile offline_access",
                            "externalAuth": {
                                "google": {
                                    "enabled": true,
                                    "label": "Continue with Google"
                                },
                                "sso": {
                                    "enabled": false,
                                    "label": "Continue with SSO"
                                }
                            }
                        }
                    },
                    "environment": "Staging"
                },
                "Production": {
                    "config": {
                        "oauth": {
                            "apiBase": "https://yaas.solomonlabs.io",
                            "clientId": "client-console-prod",
                            "redirectUri": "https://client.solomonlabs.org/callback",
                            "scope": "openid profile offline_access",
                            "externalAuth": {
                                "google": {
                                    "enabled": true,
                                    "label": "Continue with Google"
                                },
                                "sso": {
                                    "enabled": false,
                                    "label": "Continue with SSO"
                                }
                            }
                        }
                    },
                    "environment": "Production"
                }
            }
        },
        "yaas-issuer": {
            "name": "Solomon Platform",
            "shortName": "Distributor",
            "version": "1.0.0",
            "environments": {
                "Development": {
                    "config": {
                        "rpcEndpoint": "https://chloe-w2qjqk-fast-mainnet.helius-rpc.com",
                        "network": "mainnet-beta",
                        "oauth": {
                            "apiBase": "https://yaas-dev.solomonlabs.io",
                            "clientId": "issuer-console-dev",
                            "redirectUri": "http://localhost:3300/callback",
                            "scope": "openid profile offline_access",
                            "externalAuth": {
                                "google": {
                                    "enabled": true,
                                    "label": "Continue with Google"
                                },
                                "sso": {
                                    "enabled": false,
                                    "label": "Continue with SSO"
                                }
                            }
                        }
                    },
                    "environment": "Development"
                },
                "Staging": {
                    "config": {
                        "rpcEndpoint": "https://chloe-w2qjqk-fast-mainnet.helius-rpc.com",
                        "network": "mainnet-beta",
                        "oauth": {
                            "apiBase": "https://yaas-dev.solomonlabs.io",
                            "clientId": "issuer-console-dev",
                            "redirectUri": "https://staging--solomon-yaas-issuer.netlify.app/callback",
                            "scope": "openid profile offline_access",
                            "externalAuth": {
                                "google": {
                                    "enabled": true,
                                    "label": "Continue with Google"
                                },
                                "sso": {
                                    "enabled": false,
                                    "label": "Continue with SSO"
                                }
                            }
                        }
                    },
                    "environment": "Staging"
                },
                "Production": {
                    "config": {
                        "rpcEndpoint": "https://chloe-w2qjqk-fast-mainnet.helius-rpc.com",
                        "network": "mainnet-beta",
                        "oauth": {
                            "apiBase": "https://yaas.solomonlabs.io",
                            "clientId": "issuer-console-prod",
                            "redirectUri": "https://issuer.solomonlabs.org/callback",
                            "scope": "openid profile offline_access",
                            "externalAuth": {
                                "google": {
                                    "enabled": true,
                                    "label": "Continue with Google"
                                },
                                "sso": {
                                    "enabled": false,
                                    "label": "Continue with SSO"
                                }
                            }
                        }
                    },
                    "environment": "Production"
                }
            }
        },
        "yaas-issuer-legacy": {
            "name": "YaaS Issuer Console (Legacy)",
            "shortName": "Issuer Legacy",
            "version": "1.0.0",
            "environments": {
                "Development": {
                    "config": {
                        "oauth": {
                            "apiBase": "http://localhost:4000",
                            "clientId": "issuer-console-dev",
                            "redirectUri": "http://localhost:3900/callback",
                            "scope": "openid profile offline_access",
                            "externalAuth": {
                                "google": {
                                    "enabled": true,
                                    "label": "Continue with Google"
                                },
                                "sso": {
                                    "enabled": false,
                                    "label": "Continue with SSO"
                                }
                            }
                        }
                    },
                    "environment": "Development"
                },
                "Staging": {
                    "config": {
                        "oauth": {
                            "apiBase": "https://yaas-dev.solomonlabs.io",
                            "clientId": "issuer-console-dev",
                            "redirectUri": "https://solomon-yaas-issuer-legacy-staging.netlify.app/callback",
                            "scope": "openid profile offline_access",
                            "externalAuth": {
                                "google": {
                                    "enabled": true,
                                    "label": "Continue with Google"
                                },
                                "sso": {
                                    "enabled": false,
                                    "label": "Continue with SSO"
                                }
                            }
                        }
                    },
                    "environment": "Staging"
                },
                "Production": {
                    "config": {
                        "oauth": {
                            "apiBase": "https://yaas.solomonlabs.io",
                            "clientId": "issuer-console-prod",
                            "redirectUri": "https://issuer-legacy.solomonlabs.org/callback",
                            "scope": "openid profile offline_access",
                            "externalAuth": {
                                "google": {
                                    "enabled": true,
                                    "label": "Continue with Google"
                                },
                                "sso": {
                                    "enabled": false,
                                    "label": "Continue with SSO"
                                }
                            }
                        }
                    },
                    "environment": "Production"
                }
            }
        },
        "wu-poc": {
            "name": "Western Union POC Console",
            "shortName": "WU POC",
            "version": "1.0.0",
            "environments": {
                "Development": {
                    "config": {
                        "rpcEndpoint": "https://arlana-lt1k86-fast-devnet.helius-rpc.com",
                        "network": "devnet",
                        "oauth": {
                            "apiBase": "http://localhost:4000",
                            "clientId": "issuer-console-dev",
                            "redirectUri": "http://localhost:3700/callback",
                            "scope": "openid profile offline_access",
                            "externalAuth": {
                                "google": {
                                    "enabled": true,
                                    "label": "Continue with Google"
                                },
                                "sso": {
                                    "enabled": false,
                                    "label": "Continue with SSO"
                                }
                            }
                        }
                    },
                    "environment": "Development"
                },
                "Staging": {
                    "config": {
                        "rpcEndpoint": "https://arlana-lt1k86-fast-devnet.helius-rpc.com",
                        "network": "devnet",
                        "oauth": {
                            "apiBase": "https://yaas-dev.solomonlabs.io",
                            "clientId": "issuer-console-dev",
                            "redirectUri": "https://staging--solomon-wu-poc.netlify.app/callback",
                            "scope": "openid profile offline_access",
                            "externalAuth": {
                                "google": {
                                    "enabled": true,
                                    "label": "Continue with Google"
                                },
                                "sso": {
                                    "enabled": false,
                                    "label": "Continue with SSO"
                                }
                            }
                        }
                    },
                    "environment": "Staging"
                },
                "Production": {
                    "config": {
                        "rpcEndpoint": "https://arlana-lt1k86-fast-devnet.helius-rpc.com",
                        "network": "devnet",
                        "oauth": {
                            "apiBase": "https://yaas-dev.solomonlabs.io",
                            "clientId": "issuer-console-dev",
                            "redirectUri": "https://solomon-wu-poc.netlify.app/callback",
                            "scope": "openid profile offline_access",
                            "externalAuth": {
                                "google": {
                                    "enabled": true,
                                    "label": "Continue with Google"
                                },
                                "sso": {
                                    "enabled": false,
                                    "label": "Continue with SSO"
                                }
                            }
                        }
                    },
                    "environment": "Production"
                }
            }
        }
    }
}
